/* eslint-disable max-len */
import React from 'react';
import PropTypes from 'prop-types';

export const ArrowCircleRight = ({ size = 18 }) => {
  return (
    <svg width={size} height={size} viewBox="0 0 32 32" fill="currentcolor">
      <path d="M 16 3 C 8.832031 3 3 8.832031 3 16 C 3 23.167969 8.832031 29 16 29 C 23.167969 29 29 23.167969 29 16 C 29 8.832031 23.167969 3 16 3 Z M 16 5 C 22.085938 5 27 9.914063 27 16 C 27 22.085938 22.085938 27 16 27 C 9.914063 27 5 22.085938 5 16 C 5 9.914063 9.914063 5 16 5 Z M 16.71875 9.59375 L 15.28125 11 L 19.28125 15 L 9 15 L 9 17 L 19.28125 17 L 15.28125 21 L 16.71875 22.40625 L 23.125 16 Z" />
    </svg>
  );
};

ArrowCircleRight.propTypes = {
  size: PropTypes.number,
};
